import { render } from "./UpdateDnsServer.vue?vue&type=template&id=23490f16&scoped=true"
import script from "./UpdateDnsServer.vue?vue&type=script&lang=js"
export * from "./UpdateDnsServer.vue?vue&type=script&lang=js"

import "./UpdateDnsServer.vue?vue&type=style&index=0&id=23490f16&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23490f16"]])

export default __exports__